import React, { useState, useEffect } from 'react';
import {object, func, bool, string} from 'prop-types';

import {CloneObject} from '../../../utils/helpers';
import {isValidNumber} from '../../../utils/validator';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {VALIDATION_MESSAGE} from '../../../consts/validationMessage';
import {useFormErrors} from '../../hooks/useFormErrors';
import InputLista from '../../common/InputLista';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import InputNumber from '../../common/InputNumber';
import InputPercent from '../../common/InputPercent';
import {TIPS} from "../../../consts/tips";
import {Accordion, CheckboxButton, CheckboxButtonGroup, FormError, FormLabel, Modal} from "../../common"

const ObraInmuebleDetalleModal = (props) => {

    const entityInit = {
        id: 0,
        idObraInmueble: 0,
        idTipoObra: 0,
        idDestinoObra: 0,
        idFormaPresentacionObra: 0,
        idFormaCalculoObra: 0,
        sujetoDemolicion: false,
        generarSuperficie: false,
        tipoSuperficie: '',
        descripcion: '',
        valor: 0,
        alicuota: 0,
        metros: 0,
        montoPresupuestado: 0,
        montoCalculado: 0
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });
        formSet({
            idTipoObra: props.data.entity.idTipoObra,
            idDestinoObra: props.data.entity.idDestinoObra,
            idFormaPresentacionObra: props.data.entity.idFormaPresentacionObra,
            idFormaCalculoObra: props.data.entity.idFormaCalculoObra,
            sujetoDemolicion: props.data.entity.sujetoDemolicion,
            generarSuperficie: props.data.entity.generarSuperficie,
            tipoSuperficie: props.data.entity.tipoSuperficie,
            descripcion: props.data.entity.descripcion,
            valor: props.data.entity.valor,
            alicuota: props.data.entity.alicuota,
            metros: props.data.entity.metros,
            montoPresupuestado: props.data.entity.montoPresupuestado,
            montoCalculado: props.data.entity.montoCalculado
        });
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idTipoObra: 0,
        idDestinoObra: 0,
        idFormaPresentacionObra: 0,
        idFormaCalculoObra: 0,
        sujetoDemolicion: false,
        generarSuperficie: false,
        tipoSuperficie: '',
        descripcion: '',
        valor: 0,
        alicuota: 0,
        metros: 0,
        montoPresupuestado: 0,
        montoCalculado: 0
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);
        row.idTipoObra = parseInt(formValues.idTipoObra);
        row.idDestinoObra = parseInt(formValues.idDestinoObra);
        row.idFormaPresentacionObra = parseInt(formValues.idFormaPresentacionObra);
        row.idFormaCalculoObra = parseInt(formValues.idFormaCalculoObra);
        row.sujetoDemolicion = formValues.sujetoDemolicion;
        row.generarSuperficie = formValues.generarSuperficie;
        row.tipoSuperficie = formValues.tipoSuperficie;
        row.descripcion = formValues.descripcion;
        row.valor = formValues.valor;
        row.alicuota = formValues.alicuota;
        row.metros = formValues.metros;
        row.montoPresupuestado = formValues.montoPresupuestado;
        row.montoCalculado = formValues.montoCalculado;

        props.onConfirm(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTipoObra <= 0) errors.idTipoObra = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idDestinoObra <= 0) errors.idDestinoObra = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idFormaPresentacionObra <= 0) errors.idFormaPresentacionObra = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idFormaCalculoObra <= 0) errors.idFormaCalculoObra = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.tipoSuperficie.length <= 0) errors.tipoSuperficie = VALIDATION_MESSAGE.REQUIRED;
        if (formValues.descripcion.length <= 0) errors.descripcion = VALIDATION_MESSAGE.REQUIRED;
        if (!isValidNumber(formValues.valor, true)) errors.valor = 'Ingresá un número mayor a cero';
        if (!isValidNumber(formValues.alicuota, true)) errors.alicuota = 'Ingresá un número mayor a cero';
        if (!isValidNumber(formValues.metros, true)) errors.metros = 'Ingresá un número mayor a cero';
        if (!isValidNumber(formValues.montoPresupuestado, true)) errors.montoPresupuestado = 'Ingresá un número mayor a cero';
        if (!isValidNumber(formValues.montoCalculado, true)) errors.montoCalculado = 'Ingresá un número mayor a cero';

        return errors;
    }

    return (
        <>

            <Modal
                size="lg"
                title={`Obra detalle: ${(state.entity.id > 0) ? state.entity.tipoSuperficie : "Nuevo"}`}
                tipName={TIPS.NAME.MODALS.OBRA_INMUEBLE_DETALLE_MODAL}
                onEscape={() => props.onDismiss()}
                body={(
                            <div className="row">

                                <div className="mb-3 col-12 col-md-6">
                                    <FormLabel htmlFor="idTipoObra" required>Tipo obra</FormLabel>
                                    <InputLista
                                        name="idTipoObra"
                                        placeholder=""
                                        className={`form-control ${errorOf('idTipoObra') ? 'is-invalid' : ''}`}
                                        value={formValues.idTipoObra}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                        lista="TipoObra"
                                    />
                                    <FormError message={errorOf('idTipoObra')} />
                                </div>
                                <div className="mb-3 col-12 col-md-6">
                                    <FormLabel htmlFor="idDestinoObra" required>Destino obra</FormLabel>
                                    <InputLista
                                        name="idDestinoObra"
                                        placeholder=""
                                        className={`form-control ${errorOf('idDestinoObra') ? 'is-invalid' : ''}`}
                                        value={formValues.idDestinoObra}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                        lista="DestinoObra"
                                    />
                                    <FormError message={errorOf('idDestinoObra')} />
                                </div>
                                <div className="mb-3 col-12 col-md-6">
                                    <FormLabel htmlFor="idFormaPresentacionObra" required>Forma
                                        presentación</FormLabel>
                                    <InputLista
                                        name="idFormaPresentacionObra"
                                        placeholder=""
                                        className={`form-control ${errorOf('idFormaPresentacionObra') ? 'is-invalid' : ''}`}
                                        value={formValues.idFormaPresentacionObra}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                        lista="FormaPresentacionObra"
                                    />
                                    <FormError message={errorOf('idFormaPresentacionObra')} />
                                </div>
                                <div className="mb-3 col-12 col-md-6">
                                    <FormLabel htmlFor="idFormaCalculoObra" required>Forma cálculo</FormLabel>
                                    <InputLista
                                        name="idFormaCalculoObra"
                                        placeholder=""
                                        className={`form-control ${errorOf('idFormaCalculoObra') ? 'is-invalid' : ''}`}
                                        value={formValues.idFormaCalculoObra}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                        lista="FormaCalculoObra"
                                    />
                                    <FormError message={errorOf('idFormaCalculoObra')} />
                                </div>

                                <hr className="mb-3"/>
                                <div className="mb-3 col-12">
                                    <CheckboxButtonGroup label="Opciones">
                                        <CheckboxButton
                                            name="sujetoDemolicion"
                                            label="Sujeto a demolición"
                                            checked={formValues.sujetoDemolicion}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                        <CheckboxButton
                                            name="generarSuperficie"
                                            label="Generar superficie"
                                            checked={formValues.generarSuperficie}
                                            onChange={formHandle}
                                            disabled={props.disabled}
                                        />
                                    </CheckboxButtonGroup>
                                </div>

                                <hr className="mb-3"/>
                                <div className="mb-3 col-12 col-md-4">
                                    <FormLabel htmlFor="tipoSuperficie" required>Tipo superficie</FormLabel>
                                    <input
                                        name="tipoSuperficie"
                                        type="text"
                                        placeholder=""
                                        className={`form-control ${errorOf('tipoSuperficie') ? 'is-invalid' : ''}`}
                                        value={formValues.tipoSuperficie}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('tipoSuperficie')} />
                                </div>
                                <div className="mb-3 col-12 col-md-8">
                                    <FormLabel htmlFor="descripcion" required>Descripción</FormLabel>
                                    <input
                                        name="descripcion"
                                        type="text"
                                        placeholder=""
                                        className={`form-control ${errorOf('descripcion') ? 'is-invalid' : ''}`}
                                        value={formValues.descripcion}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('descripcion')} />
                                </div>

                                <hr className="mb-3"/>
                                <div className="mb-3 col-6 col-md-4">
                                    <FormLabel htmlFor="valor" required>Valor</FormLabel>
                                    <InputNumber
                                        name="valor"
                                        placeholder=""
                                        className={`form-control ${errorOf('valor') ? 'is-invalid' : ''}`}
                                        value={formValues.valor}
                                        precision={2}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('valor')} />
                                </div>
                                <div className="mb-3 col-6 col-md-4">
                                    <FormLabel htmlFor="alicuota" required>Alícuota</FormLabel>
                                    <InputPercent
                                        name="alicuota"
                                        placeholder=""
                                        className={`form-control ${errorOf('alicuota') ? 'is-invalid' : ''}`}
                                        value={formValues.alicuota}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('alicuota')} />
                                </div>
                                <div className="mb-3 col-6 col-md-4">
                                    <FormLabel htmlFor="metros" required>Metros</FormLabel>
                                    <InputNumber
                                        name="metros"
                                        placeholder=""
                                        className={`form-control ${errorOf('metros') ? 'is-invalid' : ''}`}
                                        value={formValues.metros}
                                        precision={2}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('metros')} />
                                </div>
                                <div className="mb-3 col-6 col-md-4">
                                    <FormLabel htmlFor="montoPresupuestado" required>Monto presupuestado
                                       </FormLabel>
                                    <InputNumber
                                        name="montoPresupuestado"
                                        placeholder=""
                                        className={`form-control ${errorOf('montoPresupuestado') ? 'is-invalid' : ''}`}
                                        value={formValues.montoPresupuestado}
                                        precision={2}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('montoPresupuestado')} />
                                </div>
                                <div className="mb-3 col-6 col-md-4">
                                    <FormLabel htmlFor="montoCalculado" required>Monto cálculado</FormLabel>
                                    <InputNumber
                                        name="montoCalculado"
                                        placeholder=""
                                        className={`form-control ${errorOf('montoCalculado') ? 'is-invalid' : ''}`}
                                        value={formValues.montoCalculado}
                                        precision={2}
                                        onChange={formHandle}
                                        disabled={props.disabled}
                                    />
                                    <FormError message={errorOf('montoCalculado')} />
                                </div>

                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de Obra Detalle"
                                            tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_OBRA_INMUEBLE_DETALLE_MODAL}
                                            processKey={props.processKey}
                                            entidad="ObraInmuebleDetalle"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>
                            </div>
                )}
                footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
                </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
                )}
                footerClassName={props.disabled ? 'f-align' : ''}
            />

        </>
    );
}

ObraInmuebleDetalleModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

ObraInmuebleDetalleModal.defaultProps = {
    disabled: false
};

export default ObraInmuebleDetalleModal;